const GOLD = '#FFAA00';
const GOLD_GLOW = 'rgba(255,170,0,0.40)';

export default function AvatarPremium({
  fotoUrl,
  nome,
  isPremium = false,
  size = 40,
  radius = '50%',
  className = '',
  style = {},
}) {
  const initials = nome?.charAt(0)?.toUpperCase() || '?';
  const fontSize = Math.round(size * 0.38);
  const padding = isPremium ? 2 : 0;
  const innerSize = size - padding * 2;

  return (
    <div
      className={`relative flex-shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        padding: isPremium ? padding : 0,
        background: isPremium ? GOLD : 'transparent',
        boxShadow: isPremium ? `0 0 8px ${GOLD_GLOW}` : 'none',
        ...style,
      }}
    >
      <div
        className="overflow-hidden flex items-center justify-center font-extrabold text-white"
        style={{
          width: innerSize,
          height: innerSize,
          borderRadius: radius,
          background: 'linear-gradient(150deg,#6E50F0,#3F27B0)',
          fontSize,
        }}
      >
        {fotoUrl
          ? <img src={fotoUrl} alt={nome || ''} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          : initials
        }
      </div>
      {isPremium && (
        <span
          className="absolute -bottom-[3px] -right-[3px] leading-none pointer-events-none select-none"
          style={{ fontSize: Math.max(9, Math.round(size * 0.28)) }}
        >
          ✨
        </span>
      )}
    </div>
  );
}
